import { Model } from "@interfaces/model.interface";

export interface Group extends Model {
	isSelected: boolean;
	name: string;
}

export class Group implements Group {
	constructor(data?: Partial<Group>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}